export default __webpack_public_path__ + "static/media/249112.48cb06e4.webp";